<script setup>
import LogoModal from '@/components/modal/LogoModal.vue';

defineProps({
  title: String,
  src: String,
});

const emit = defineEmits(['close']);

const close = () => emit('close');
</script>
<template>
  <logo-modal @close="close">
    <template v-slot:body>
      <div class="flex flex-col overflow-y-auto">
        <h2 class="text-center tablet:text-[2rem] mt-[1rem] mb-[1rem]" v-html="title"></h2>
        <div
          class="
            mx-auto
            tablet:pb-8
            w-[100%]
            tablet:w-[90%]
            desktop:w-[80%]
            desktop-xl:w-[70%]
        ">
          <div class="relative pb-[56.25%] h-0">
            <iframe
            class="absolute w-full h-full"
            :title="title"
            :src="src"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </template>
  </logo-modal>
</template>
